import getGeneralImage from '../getGeneralImage';

/**
 * @function getBannerImage -Function to get relevent banner images
 * @param {*} props - Strapi Data
 * @returns {string} - Responsive images based on desktop,mobile and tablet view
 */
export const getBannerImage = props => {
    const bannerMobile = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Banner_Images,
            key: 'bannerImage',
            view: 'MobileViewImage',
        }).url
    }`;
    const bannerTablet = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Banner_Images,
            key: 'bannerImage',
            view: 'TabletViewImage',
        }).url
    }`;
    const bannerDesktop = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Banner_Images,
            key: 'bannerImage',
            view: 'DesktopViewImage',
        }).url
    }`;
    const chevron = `${
        getGeneralImage({
            generalImageArray: props.cmsData?.Banner_Images,
            key: 'chevron',
            view: 'DesktopViewImage',
        }).url
    }`;
    return { bannerMobile, bannerDesktop, bannerTablet, chevron };
};
